import React from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Collapse, Panel } from 'react-bootstrap';
import dropbox from '../imgs/dropbox.svg';
import google from '../imgs/google-drive.svg';
import box from '../imgs/box.svg';
import ButtonWithImage from '../ButtonWithImage';
import './styles';
import NewAttachmentsContainer from './_NewAttachmentsContainer';
import { FILE_SOURCES, FILE_MAX_SIZE_ALLOWED } from './constants';
import Attachments from './Attachments';
import PropTypes from 'prop-types';

@injectIntl
@inject('rootStore')
@observer
export default class AttachmentsForm extends React.Component {
  @observable showPopover = false;
  @observable dragOver = false;

  render() {
    const { attachable, renderHidePreview, intl } = this.props;
    return (
      <div>
        <Attachments
          attachable={attachable}
          renderHidePreview={renderHidePreview}
        />

        <NewAttachmentsContainer
          attachable={attachable}
          handleClick={() => this.upload.click()}
        />
        <Collapse className="attachments-collapse" in={this.showPopover}>
          <Panel>
            <i className="fa fa-remove" onClick={this.toggleShowPopover}></i>

            <div
              className={'drop-zone ' + (this.dragOver ? 'drag-over' : '')}
              onClick={() => this.upload.click()}
              onDrop={this.handleFileDrop}
              onDragOver={this.handleDragOver}
              onDragEnter={this.handleDragEnter}
              onDragLeave={this.handleDragLeave}
            >
              <div>{intl.formatMessage({ id: 'drop_files_message' })}</div>
              <div className="bold">
                {intl.formatMessage({ id: 'drop_files_click_here' })}
              </div>
            </div>

            <input
              style={{ display: 'none' }}
              className=""
              id="file-upload"
              ref="upload"
              type="file"
              accept=".mkv, .mp4, .json, .txt, .xml, .pdf, .zip, .rar, .doc, .dot, .docx, .xls, .xlsx, .jpeg, .jpg, .png, .bmp"
              onChange={this.handleAttachmentChange}
              onClick={null}
              ref={ref => (this.upload = ref)}
            />

            <ButtonWithImage
              label="DropBox"
              image={dropbox}
              onClick={this.handleDropboxChooser}
            />

            <ButtonWithImage
              label="Google"
              image={google}
              onClick={this.handleGooglePicker}
            />

            <ButtonWithImage
              label="Box"
              image={box}
              onClick={this.handleBoxPicker}
            />
          </Panel>
        </Collapse>

        {!this.showPopover && (
          <a
            href={'#'}
            className="add-attachment"
            onClick={this.toggleShowPopover}
            ref={element => (this.buttonRef = element)}
            style={{ marginBottom: '5px', width: '158px' }}
          >
            {intl.formatMessage({ id: 'add_attachment' })}
          </a>
        )}

        <br />
      </div>
    );
  }

  @action
  handleFileDrop = e => {
    e.stopPropagation();
    e.preventDefault();
    if (e.dataTransfer.files[0]) {
      this.props.attachable.addAttachment(e.dataTransfer.files[0]);
    } else {
      return null;
    }
    this.toggleShowPopover();
  };

  @action
  handleDragOver = e => {
    e.stopPropagation();
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
  };

  @action
  handleDragLeave = e => {
    e.stopPropagation();
    e.preventDefault();
    this.dragOver = false;
  };

  @action
  handleDragEnter = e => {
    e.stopPropagation();
    e.preventDefault();
    this.dragOver = true;
  };

  validateFileSize = file => {
    const size = Math.round(file.size / 1024);
    return size < FILE_MAX_SIZE_ALLOWED;
  };

  @action
  handleAttachmentChange = event => {
    if (event.target.files[0]) {
      if (this.validateFileSize(event.target.files[0]))
        this.props.attachable.addAttachment(event.target.files[0]);
      else alert('Uploaded file size must be less than 10MB');
    } else {
      return null;
    }
    this.toggleShowPopover();
  };

  @action
  handleDropboxChooser = () => {
    const { attachable } = this.props;

    Dropbox.choose({
      success: files => {
        let file = files[0];
        file.isExternal = true;
        file.url = file.link;
        file.source = FILE_SOURCES.DROPBOX;
        attachable.addAttachment(file);
      }
    });

    this.toggleShowPopover();
  };

  @action
  handleGooglePicker = () => {
    const { rootStore, attachable } = this.props;
    rootStore.googlePicker.pick({
      success: file => {
        file.isExternal = true;
        file.source = FILE_SOURCES.GOOGLE;
        attachable.addAttachment(file);
      }
    });

    this.toggleShowPopover();
  };

  @action
  handleBoxPicker = () => {
    const { rootStore, attachable } = this.props;

    rootStore.boxPicker.pick({
      success: file => {
        file.isExternal = true;
        file.source = FILE_SOURCES.BOX;
        attachable.addAttachment(file);
      }
    });

    this.toggleShowPopover();
  };

  @action
  toggleShowPopover = e => {
    if (e) {
      try {
        e.stopPropagation();
        e.preventDefault();
      } catch (err) {
        console.log(err);
      }
    }
    this.showPopover = !this.showPopover;
  };
}

AttachmentsForm.propTypes = {
  attachable: PropTypes.object
};

AttachmentsForm.defaultProps = {
  renderHidePreview: false
};
